"use strict";

define([], function () {
    var passiveSupported = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            get: function get() {
                passiveSupported = true;
            }
        });

        window.addEventListener("test", null, options);
    } catch (err) {}

    var getEventListenerOptions = void 0;
    if (passiveSupported) {
        getEventListenerOptions = function setupEventListenerOptions(options) {
            var eventObj = {};
            var capture = options.capture || false;
            var once = options.once || false;
            eventObj.capture = capture;
            eventObj.once = once;
            var passive = options.passive;
            if (passive === true || passive === false) {
                // If statement to so we use "browser default"
                // if "passive" is not explicitly set.
                eventObj.passive = passive;
            }
            return eventObj;
        };
    } else {
        getEventListenerOptions = function setupEventListenerOptions(options) {
            return options.capture || false;
        };
    }

    return {
        passiveSupported: passiveSupported,
        getOptions: getEventListenerOptions
    };
});

